"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DropdownCardGroup;
var _react = _interopRequireDefault(require("react"));
var _DropdownCard = _interopRequireDefault(require("../DropdownCard"));
var _classnames = _interopRequireDefault(require("classnames"));
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function DropdownCardGroup(_a) {
  var cardList = _a.cardList,
    className = _a.className,
    _b = _a.defaultHeight,
    defaultHeight = _b === void 0 ? '350px' : _b;
  var rows = Math.ceil(cardList.length / 2);
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: (0, _classnames["default"])('dropdown-card-group', className)
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "dropdown-cards-container",
    style: {
      gridTemplateRows: "repeat(" + rows + ", minmax(" + defaultHeight + ", " + defaultHeight + "))"
    }
  }, cardList.map(function (card, idx) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "dropdown-card-wrapper",
      key: "dropdown-card-group-item-" + idx
    }, /*#__PURE__*/_react["default"].createElement(_DropdownCard["default"], __assign({}, card)));
  })));
}